<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
    />
    <div class="p-3 bg-secondary-1">
      <validation-observer ref="formValidator">
        <filter-manager
          v-model="filterModel"
          :options="filterOptions"
          @search="search"
        />
      </validation-observer>
    </div>
    <div v-if="isMobile" class="mt-3">
      <compact-tab
        :items="tabs"
        :tab-id="activeTab"
        @set-active-tab="setCompactActiveTab"
      />
      <keep-alive>
        <component
          :is="activeTab"
          ref="currenTab"
          :filters="filterModel"
          :items="results"
          :pagination="paginationModel"
          @load="load"
        />
      </keep-alive>
    </div>
    <tab-header
      v-else
      class="mt-2"
      content-class="text-center"
      nav-class="custom-nav-container mx-0 "
      :no-nav-style="true"
    >
      <tab-item-header lazy>
        <template v-slot:title>
          <i class="fas fa-clock mr-2"></i>
          Informes recientes
        </template>
        <template v-slot:content>
          <recents
            :filters="filterModel"
            :items="results"
            @load="loadRecents"
          />
        </template>
      </tab-item-header>
      <tab-item-header lazy title="Mis favoritos" nav-active-class="text-green">
        <template v-slot:title>
          <i class="fa-regular fa-star mr-2"></i>
          Mis favoritos
        </template>
        <template v-slot:content>
          <my-favorites
            :filters="filterModel"
            :items="results"
            :pagination="paginationModel"
            @load="loadFavorites"
            @change-page="changePage"
          />
        </template>
      </tab-item-header>
      <tab-item-header lazy title="Mis informes" nav-active-class="text-green">
        <template v-slot:title>
          <i class="far fa-folder-open mr-2"></i>
          Mis informes
        </template>
        <template v-slot:content>
          <my-reports
            :filters="filterModel"
            :items="results"
            :pagination="paginationModel"
            @load="loadMyReports"
            @change-page="changePage"
          />
        </template>
      </tab-item-header>
      <tab-item-header
        lazy
        title="Compartidos conmigo"
        nav-active-class="text-green"
      >
        <template v-slot:title>
          <i class="fas fa-link mr-2"></i>
          Compartidos conmigo
        </template>
        <template v-slot:content>
          <shared-with-me
            :filters="filterModel"
            :items="results"
            :pagination="paginationModel"
            @load="loadSharedWithMe"
            @change-page="changePage"
          />
        </template>
      </tab-item-header>
      <tab-item-header lazy title="Inactivos" nav-active-class="text-green">
        <template v-slot:title>
          <i class="fas fa-ban mr-2"></i>
          Inactivos
        </template>
        <template v-slot:content>
          <inactive
            :filters="filterModel"
            :items="results"
            :pagination="paginationModel"
            @load="loadInactives"
            @change-page="changePage"
          />
        </template>
      </tab-item-header>
    </tab-header>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { name as specialReportModuleName } from '@/modules/special-report/store'
import PageHeader from 'PageHeader'
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator'
import SpecialService from '@/services/api/special.api'
import { TabItemHeader, TabHeader, CompactTab } from '@/components/common/tabs'
import FilterManager from './components/FilterManager.vue'
import MyReports from './tabs/MyReports.vue'
import Inactive from './tabs/Inactive.vue'
import MyFavorites from './tabs/MyFavorites.vue'
import Recents from './tabs/Recents.vue'
import SharedWithMe from './tabs/SharedWithMe.vue'
import hubservice from '@/services/api/hub/hubservice.js'
import Vue from 'vue'

//constants
const SPECIAL_REPORT_MANAGEMENT_ROUTE_NAME = 'SpecialReportManager'

export default {
  name: 'SpecialReportsMain',
  components: {
    PageHeader,
    TabItemHeader,
    TabHeader,
    CompactTab,
    FilterManager,
    MyReports,
    Inactive,
    MyFavorites,
    Recents,
    SharedWithMe,
  },
  mixins: [storeMixin],
  data: () => ({
    results: [],
    filterOptions: {
      topics: [],
      tags: [],
    },
    filterModel: {
      name: null,
      topic: null,
      tag: null,
      isActive: true,
      favorites: false,
      recents: false,
      shareWithMe: false,
      onlyMine: true,
    },
    paginationModel: {
      perPage: 10,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
    currentTab: null,
    activeTab: 'Recents',
    tabs: [
      {
        Id: 'Recents',
        Name: 'Recents',
        load: () => this.loadRecents(),
        page: {
          tabIndex: 1,
          icon: 'fa-regular fa-clock',
          title: 'Informes recientes',
        },
      },
      {
        Id: 'MyFavorites',
        Name: 'MyFavorites',
        load: () => this.loadFavorites(),
        page: {
          tabIndex: 2,
          icon: 'fa-regular fa-star',
          title: 'Mis favoritos',
        },
      },
      {
        Id: 'MyReports',
        Name: 'MyReports',
        load: () => this.loadMyReports(),
        page: {
          tabIndex: 2,
          icon: 'far fa-folder-open',
          title: 'Mis informes',
        },
      },
      {
        Id: 'SharedWithMe',
        Name: 'SharedWithMe',
        load: () => this.loadSharedWithMe(),
        page: {
          tabIndex: 2,
          icon: 'fas fa-link',
          title: 'Compartidos conmigo',
        },
      },
      {
        Id: 'Inactive',
        Name: 'Inactive',
        load: () => this.loadInactives(),
        page: {
          tabIndex: 2,
          icon: 'fas fa-ban',
          title: 'Inactivos',
        },
      },
    ],
  }),
  computed: {
    ...mapState(specialReportModuleName, ['tagsCounter', 'hasTickets']),
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    headerConfig() {
      return {
        title: 'Informes Especiales',
        icon: 'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Informes Especiales'],
      }
    },
    headerActionsConfig() {
      return [
        {
          text: 'Crear Informe',
          icon: 'fas fa-file-plus pr-2',
          variant: 'success ml-0',
          click: () => this.onAddHandler(),
        },
      ]
    },
    closePanel() {
      return this.closeAllPanels
    },
  },
  watch: {
    tagsCounter: function (newValue) {
      if (newValue) this.initFilter()
    },
    hasTickets: function () {
      this.existReportsWithTickets()
    },
  },
  mounted() {
    this.initFilter()
    this.existReportsWithTickets()
    if (this.isMobile) {
      this.load()
    }
  },
  created() {
    Vue.use(hubservice)
    this.$userHub.$on('hub-recieve-status-queue', this.updateQueueStatusByhub)

    /* eslint-disable no-debugger, no-console */
    console.log("hub-recieve-status-queue------------on'")
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off('hub-recieve-status-queue', this.updateQueueStatusByhub)

    /* eslint-disable no-debugger, no-console */
    console.log("hub-recieve-status-queue------------off'")
  },
  methods: {
    ...mapActions(specialReportModuleName, ['setCurrentRow']),
    async setCompactActiveTab(menuItem) {
      const { Id: tabId } = menuItem
      if (tabId) {
        this.activeTab = tabId
        this.load()
      }
    },
    async initFilter() {
      const { data } = await SpecialService.getInitFilters()

      const activeTags = data.tags.filter((e) => e.activeFlag)
      const inactiveTags = data.tags.filter(
        (e) => !e.activeFlag && e.haveAnyInform
      )

      this.filterOptions.topics = data.topics
      this.filterOptions.tags = [...activeTags, ...inactiveTags]
      this.existReportsWithTickets()
    },
    onAddHandler() {
      this.$router.push({
        name: SPECIAL_REPORT_MANAGEMENT_ROUTE_NAME,
      })
    },
    updateQueueStatusByhub(res) {
      const infoUpdated = res?.respose

      const index = this.results.findIndex((item) => {
        return item.id == infoUpdated.queryBuilderId
      })

      this.results[index].statusQueue = infoUpdated.status
      this.results[index].messageQueue = infoUpdated.message
    },
    async search() {
      this.setCurrentRow(null)
      const { data } = await SpecialService.search({
        onlyMine: this.filterModel.onlyMine,
        name: this.filterModel.name,
        topicId: this.filterModel.topic?.id,
        tagId: this.filterModel.tag?.id,
        isActive: this.filterModel.isActive,
        anyFavorite: this.filterModel.favorites,
        recents: this.filterModel.recents,
        shareWithMe: this.filterModel.shareWithMe,
        pageIndex: this.paginationModel.currentPage,
        pageSize: this.paginationModel.perPage,
      })
      if (data) {
        this.results = [...data.data]
        this.paginationModel = {
          ...this.paginationModel,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        }
      }
    },
    changePage(currentPage) {
      this.paginationModel.currentPage = currentPage
      this.search()
    },
    loadFavorites() {
      this.filterModel.onlyMine = false
      this.filterModel.shareWithMe = false
      this.filterModel.name = null
      this.filterModel.topic = null
      this.filterModel.tag = null
      this.filterModel.isActive = true
      this.filterModel.favorites = true
      this.filterModel.recents = false
      const tabName = 'favorites'
      if (tabName != this.currentTab) {
        this.paginationModel.currentPage = 1
        this.currentTab = tabName
      }
      this.search()
    },
    loadInactives() {
      this.filterModel.onlyMine = false
      this.filterModel.shareWithMe = false
      this.filterModel.name = null
      this.filterModel.topic = null
      this.filterModel.tag = null
      this.filterModel.isActive = false
      this.filterModel.favorites = false
      this.filterModel.recents = false
      const tabName = 'inactives'
      if (tabName != this.currentTab) {
        this.paginationModel.currentPage = 1
        this.currentTab = tabName
      }
      this.search()
    },
    loadMyReports() {
      this.filterModel.onlyMine = true
      this.filterModel.shareWithMe = false
      this.filterModel.name = null
      this.filterModel.topic = null
      this.filterModel.tag = null
      this.filterModel.isActive = true
      this.filterModel.favorites = false
      this.filterModel.recents = false
      const tabName = 'myReoorts'
      if (tabName != this.currentTab) {
        this.paginationModel.currentPage = 1
        this.currentTab = tabName
      }
      this.search()
    },
    loadRecents() {
      this.filterModel.onlyMine = false
      this.filterModel.shareWithMe = false
      this.filterModel.name = null
      this.filterModel.topic = null
      this.filterModel.tag = null
      this.filterModel.isActive = true
      this.filterModel.favorites = false
      this.filterModel.recents = true
      this.paginationModel.perPage = 10
      const tabName = 'recents'
      if (tabName != this.currentTab) {
        this.paginationModel.currentPage = 1
        this.currentTab = tabName
      }
      this.search()
    },
    loadSharedWithMe() {
      this.filterModel.onlyMine = false
      this.filterModel.shareWithMe = true
      this.filterModel.name = null
      this.filterModel.topic = null
      this.filterModel.tag = null
      this.filterModel.isActive = true
      this.filterModel.favorites = false
      this.filterModel.recents = false
      this.search()
    },
    load() {
      switch (this.activeTab) {
        case 'Recents':
          this.loadRecents()
          break
        case 'MyFavorites':
          this.loadFavorites()
          break
        case 'MyReports':
          this.loadMyReports()
          break
        case 'SharedWithMe':
          this.loadSharedWithMe()
          break
        case 'Inactive':
          this.loadInactives()
          break

        default:
          break
      }
    },
    async existReportsWithTickets() {
      const exist = this.filterOptions.tags.find((e) => e.id == 0)
      const { data } = await SpecialService.hasTickets()
      if (data && !exist) {
        this.filterOptions.tags.push({
          tagId: 18,
          name: 'DETickets',
          queryBuilderId: 0,
          activeFlag: true,
          haveAnyInform: false,
          id: 0,
          selected: false,
          disabled: false,
          isDirty: false,
          sortOrder: 0,
        })
      } else if (!data && exist) {
        const idx = this.filterOptions.tags.indexOf(exist)
        this.filterOptions.tags.splice(idx, 1)
      }
    },
  },
}
</script>
<style>
.bg-secondary-1 {
  background-color: #fafafa;
}
</style>
